/**
 * Created by nijin on 28/12/16.
 */
import {
  Component, OnInit, ContentChild, ContentChildren, QueryList, AfterContentInit, OnChanges,
  SimpleChanges,ViewChild
} from '@angular/core';
import {WizardContentComponent} from "./wiz-content.component";
import {ThingsCommonHeaderComponent} from "./wiz-cmn-header";

@Component({
  selector: 'nuc-wizard',
  template:`
   <nuc-wiz-menu [wizSteps]="wizardSteps" [activeStep]="getActiveStepDetails()"></nuc-wiz-menu>
   <nuc-wiz-cmn-header #header [activeStep]="getActiveStepDetails()" [next]="getNextStep()" 
   [previous]="getPreviousStep()" (changeStep)="selectStep($event)" *ngIf="getNextStep()"></nuc-wiz-cmn-header>
   <div class="thingsFormContents clearfix">
   <ng-content></ng-content>
   </div>
`,
styles: [
      `.thingsFormContents{
          padding: 25px 15px; 
       }
       @media(max-width: 767px){
        .thingsFormContents{
          padding: 25px 0px;
        }
       }`
    ]

})
export class WizardComponent implements OnInit, AfterContentInit {
  @ContentChildren(WizardContentComponent) wizardSteps: QueryList<WizardContentComponent>;
  @ViewChild('header') header: ThingsCommonHeaderComponent;
  constructor() { }

  ngOnInit() { }


  ngAfterContentInit() {
    // get all active wizard
    let activeSteps = this.wizardSteps.filter((wizard)=>wizard.active);

    // if there is no active wizard set, activate the first
    if(activeSteps.length === 0) {
      this.selectStep(this.wizardSteps.first);
    }
  }
  selectStep(wiz: WizardContentComponent){
    this.wizardSteps.toArray().forEach(tab => tab.active = false);
    wiz.active = true;
  }

  getPreviousStep(){
    let index = this.wizardSteps.toArray().findIndex((item)=> item.active);
    if(index == 0)
      return null;

    return this.wizardSteps.toArray()[index-1];
  }

  getNextStep(){
    let index = this.wizardSteps.toArray().findIndex((item)=> item.active);
    if(index == this.wizardSteps.length)
      return null;

    return this.wizardSteps.toArray()[index + 1];
  }

  getActiveStepDetails(){
     return this.wizardSteps.filter((wizard)=>wizard.active)[0];

  }


}



// WEBPACK FOOTER //
// ./src/app/things/shared/wizard/wizard.component.ts